import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import { EducationCard } from "./EducationCard";
import { Timeline } from "./Timeline";
import { Experiences } from "./Experiences";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg4 from "../assets/img/project-img4.png";
import projImg5 from "../assets/img/project-img5.png";
import projImg6 from "../assets/img/project-img6.png";
import projImg7 from "../assets/img/project-img7.png";
import projImg8 from "../assets/img/project-img8.png";
import projImg9 from "../assets/img/project-img9.png";
import eduImg1 from "../assets/img/education-img1.png";
import eduImg2 from "../assets/img/education-img2.png";
import eduImg3 from "../assets/img/education-img3.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

    const projects = [
        {
            title: "Portugal Website",
            description: "A tourism website that simplifies finding information about Portugal.",
            imgUrl: projImg1,
            githubLink: "https://github.com/devintwx/Visit-Potugal",
            liveDemoLink: "https://devintwx.github.io/Visit-Potugal/landing%20page/landingpage.html"
        },
        {
            title: "Robot War Simulator",
            description: "A simulator implemented in standard C++ that simulates a battlefield where robots compete in warfare following specific rules and behaviors.",
            imgUrl: projImg2,
            githubLink: "https://github.com/En0chTan/Robot-War-Simulator",
            liveDemoLink: "https://github.com/En0chTan/Robot-War-Simulator"
        },
        {
            title: "Predicting F1 Pit Stops",
            description: "A machine learning and analytics dashboard for predicting and analyzing Formula 1 pit stop decisions using Kaggle Competition Data.",
            imgUrl: projImg3,
            githubLink: "https://github.com/En0chTan/Predicting-F1-PitStops",
            liveDemoLink: "https://predicting-f1-pitstops.streamlit.app/"
        },
        {
            title: "Discover Kerteh",
            description: "A modern tourism website designed to promote the hidden gem of Kerteh, a coastal town in Terengganu, Malaysia.",
            imgUrl: projImg4,
            githubLink: "https://github.com/En0chTan/Discover-Kerteh",
            liveDemoLink: "https://discover-kerteh.vercel.app/"
        },
        {
            title: "Rock-Paper-Scissors Arena",
            description: "An interactive game using hand gestures for single-player and multiplayer modes, powered by computer vision for real-time hand detection and gameplay.",
            imgUrl: projImg5,
            githubLink: "https://github.com/En0chTan/Rock-Paper-Scissors-Arena",
            liveDemoLink: "https://github.com/En0chTan/Rock-Paper-Scissors-Arena"
        },
        {
            title: "Chatbot Arsenal",
            description: "A collection of large language model (LLM) powered chatbots designed for various purposes.",
            imgUrl: projImg6,
            githubLink: "https://github.com/En0chTan/Chatbot-Arsenal",
            liveDemoLink: "https://github.com/En0chTan/Chatbot-Arsenal"
        },
        {
            title: "MyDOIT",
            description: "A finance management web application that helps users track their expenses, set budgets, and manage their finances effectively.",
            imgUrl: projImg7,
            githubLink: "https://github.com/En0chTan/MyDOIT",
            liveDemoLink: "https://mydoitt.vercel.app/login"
        },
        {
            title: "ArtEmo",
            description: "An intelligent multimodal AI system that analyzes visual artworks, predicts evoked emotional responses, and generates affective captions describing the emotional interpretation of art.",
            imgUrl: projImg8,
            githubLink: "https://github.com/En0chTan/ArtEmo-Emotion-Analysis-of-Visual-Art-Images",
            liveDemoLink: "https://artemo.streamlit.app/"
        },
        {
            title: "OpenClaw Bot",
            description: "A self-hosted Discord AI assistant powered by GitHub Copilot and Google Gemini, running locally via Docker Desktop using the OpenClaw gateway.",
            imgUrl: projImg9,
            githubLink: "",
            liveDemoLink: ""
        }
    ];

    const education = [
        {
            education: "Multimedia University",
            startYear: "Aug 2022",
            endYear: "Present",
            imgSrc: eduImg1,
            description: `
            Malaysian University English Test (MUET): Band 4.5

            Courses Title:
            
            Bachelor's Degree in Computer Science (Hons.)
            - Integrity and Leadership
            - Workplace Communication
            - Chess
            - Programming Fundamentals
            - Calculus
            - Discrete Structures and Probability
            - Professional Development
            - Character Building (St.John Ambulance of Malaysia)
            - Object-Oriented Programming and Data Structures
            - Database Fundamentals
            - Computational Methods
            - Computer Architecture and Organization
            - Sports Science
            - Research Methodology in Computer Science
            - Penghayatan Etika dan Peradaban
            - Philosophy and Current Issues
            - Object-Oriented Analysis and Design
            - Software Engineering Fundamentals
            - Operating Systems
            - Computer Networks
            - Japanese for Beginners
            - Data Science Fundamentals
            - Statistical Data Analysis
            - Algorithm Design and Analysis
            - Cryptography and Data Security
            - Data Mining
            - Machine Learning
            - Visual Information Processing
            - Final Year Project Part 1
            - Data Visualization
            - Social Media Computing
            - Artificial Intelligence
            - Final Year Project Part 2

            Foundation in Information Technology
            - Introduction to Computing Technologies
            - Communicative English
            - Mathematics 1
            - Introduction to Business Management
            - Essential English
            - Multimedia Fundamentals
            - Mathematics 2
            - Problem Solving and Program Design
            - Critical Thinking
            - Introduction to Digital Systems
            - Academic English
            - Mathematics 3
            - Principles of Physics
            - Mini IT Project
        `
        },
        {
            education: "SMK Rantau Petronas",
            startYear: "Jan 2017",
            endYear: "Mar 2022",
            imgSrc: eduImg2,
            description: `
            Malaysian Certificate of Education (SPM):
            - Malay Language
            - English Language
            - Moral Education
            - History
            - Mathematics
            - Additional Mathematics
            - Physics
            - Chemistry
            - Biology

            Form Three Assessment Test (PT3):
            - Malay Language
            - Malay Language (Aural)
            - English Language
            - History
            - Geography
            - Mathematics
            - Science
            - Computer Science Fundamentals
        `
        },
        {
            education: "SJKC Chee Mong",
            startYear: "Jan 2011",
            endYear: "Nov 2016",
            imgSrc: eduImg3,
            description: `
            Primary School Achievement Test (UPSR):
            - Chinese Language (Writing)
            - Chinese Language (Comprehension)
            - Malay Language (Writing)
            - Malay Language (Comprehension)
            - English Language (Writing)
            - English Language (Comprehension)
            - Science
            - Mathematics
        `
        },
    ];

    return (
        <section className="project" id="projects">
            <Container>
                <Row>
                    <Col size={12}>
                        <TrackVisibility>
                            {({ isVisible }) =>
                                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                                    <h2>Explore</h2>
                                    <p>Discover my projects, education, and memorable experiences. Each one has played a part in shaping my skills and perspective, reflecting my growth and learning along the way.</p>
                                    <Tab.Container id="projects-tabs" defaultActiveKey="first">
                                        <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                                            <Nav.Item>
                                                <Nav.Link eventKey="first">Projects</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="second">Education</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="third">Timeline</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="fourth">Experiences</Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                        <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                                            <Tab.Pane eventKey="first">
                                                <Row>
                                                    {
                                                        projects.map((project, index) => {
                                                            return (
                                                                <ProjectCard
                                                                    key={index}
                                                                    {...project}
                                                                />
                                                            )
                                                        })
                                                    }
                                                </Row>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="second">
                                                <Row>
                                                    {
                                                        education.map((edu, index) => {
                                                            return (
                                                                <EducationCard
                                                                    key={index}
                                                                    {...edu}
                                                                />
                                                            )
                                                        })
                                                    }
                                                </Row>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="third">
                                                <Timeline />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="fourth">
                                                <Experiences />
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Tab.Container>
                                </div>}
                        </TrackVisibility>
                    </Col>
                </Row>
            </Container>
            <img className="background-image-right" src={colorSharp2} alt="decorative background" />
        </section>
    )
}